import { statusLabels, trackerStatusLabels } from '@/lib/status'

const LABELS: Record<string, string> = { ...statusLabels, ...trackerStatusLabels }

/** A ticket, tracked item or Linear state in words: the help desk's own labels where it has one. */
export function stateLabel(state: string): string {
  return LABELS[state] ?? state
}
